import { Select } from "@cofano/cck";
type Cargo = { id: number, cargoNumber?: string | null, containerNumber?: string | null, product?: { name?: string | null, description?: string | null } | null };

type CargoDocumentCargoSelectProps = {
	cargos: Cargo[];
	value: Cargo[];
	onChange: (cargos: Cargo[] | null) => void;
}
const CargoDocumentCargoSelect = ({ cargos, value, onChange }: CargoDocumentCargoSelectProps) => {
	return <Select
		fetchOptions={cargos}
		getOptionLabel={(c: Cargo) => c?.cargoNumber ?? c?.containerNumber ?? c?.product?.name ?? c?.product?.description ?? ""}
		value={value}
		onChange={onChange}
		clearable
		multiple
		disableSearch />;
};

export default CargoDocumentCargoSelect;
